import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import type { SupportedModules } from '../providers/FeatureFlag.provider';
import { DEFAULT_MODULE } from '../constants';

export const pathModuleMap: { [key: string]: SupportedModules } = {
  myAccount: 'myAccount',
  'account-summary': 'myAccount',
  'account-summary-new': 'myAccount',
  'account-and-billing': 'myAccount',
  'fund-my-account': 'myAccount',
  'link-my-account': 'myAccount',
  'withdraw-my-account': 'myAccount',
  'bank-account-transfer': 'myAccount',
  'operational-accounts': 'myAccount',
  'auto-balance-transfer': 'myAccount',
  'update-auto-balance-transfer': 'myAccount',
  'create-auto-balance-transfer': 'myAccount',
  'transaction-approval': 'transactionApproval',
  subAccounts: 'subAccounts',
  'sub-accounts-list': 'subAccounts',
  'sub-account-transaction': 'subAccounts',
  'create-sub-account': 'subAccounts',
  'sub-account-transfer': 'subAccounts',
  'sub-accounts': 'subAccounts',
  'edit-sub-accounts-permissions': 'subAccounts',
  clientAccounts: 'clientAccounts',
  'client-accounts': 'clientAccounts',
  'client-accounts-list': 'clientAccounts',
  'client-account-transfer-funds': 'clientAccounts',
  'add-client-account': 'clientAccounts',
  'client-account-schedule': 'clientAccounts',
  elinx: 'eLinx',
  'elinx-history': 'eLinx',
  payment: 'payment',
  'single-payment': 'payment',
  'bulk-payment': 'payment',
  'single-payment-review': 'payment',
  'single-payment-new': 'payment',
  'bill-payment': 'payment',
  collection: 'collection',
  'single-collection': 'collection',
  'single-collection-review': 'collection',
  'single-collection-new': 'collection',
  'bulk-collection': 'collection',
  conversion: 'conversion',
  contacts: 'contacts',
  'contact-list': 'contacts',
  'contact-file-upload': 'contacts',
  'contact-download-template': 'contacts',
  'contact-create': 'contacts',
  'contact-details': 'contacts',
  upload: 'upload',
  'file-upload': 'upload',
  'file-upload-history': 'upload',
  'download-template': 'upload',
  software: 'software',
  receivables: 'software',
  payables: 'software',
  transactions: 'transactions',
  'scheduled-transactions': 'transactions',
  statements: 'statements',
  'transactions-history': 'statements',
  'bank-verify-history': 'statements',
  reports: 'statements',
  'create-report': 'statements',
  reconciliation: 'statements',
  integrations: 'integrations',
  settings: 'settings',
  support: 'support',
  tickets: 'support',
  category: 'support',
  'create-tickets': 'support',
  'learning-centre': 'support',
  faq: 'support',
  'faq-search-result': 'support',
  users: 'users',
  'global-send': 'globalSend',
  'interest-accounts': 'interestAccounts',
  'dispute-management': 'disputeManagement',
};
const useActiveModule = (): { activeModule: SupportedModules } => {
  const { pathname } = useLocation();

  const [, moduleName] = pathname.split('/');

  const [activeModule, setActiveModule] = useState<SupportedModules>(
    pathModuleMap[moduleName.split('/')[1]] || DEFAULT_MODULE,
  );
  useEffect(() => {
    setActiveModule(pathModuleMap[moduleName] || DEFAULT_MODULE);
  }, [pathname]);
  return { activeModule };
};

export default useActiveModule;
